<template>
  <div class="px-2; shopping_cart_menu" id="paimprimir">
    <table class="table table-hover">
      <thead v-if="cartItems.length">
        <tr>
          <td></td>
          <td class="text-center">{{ $t('app.modules.orders.headers.quantity') }}</td>
          <!--<td class="text-center" v-if="!isDropDown">{{ $t('app.modules.orders.headers.qty') }}</td>-->
          <td class="text-center" v-if="!isDropDown">{{ $t('app.modules.orders.headers.unit') }}</td>

          <td class="text-center" v-if="!isDropDown">{{ $t('app.modules.orders.headers.delivery_date') }}</td>
          <td v-if="!isDropDown"></td>
          <td class="text-center" v-if="!isDropDown">{{ $t('app.modules.orders.headers.unitPrice') }}</td>
          <td class="text-center" v-if="!isDropDown">{{ $t('app.modules.order_model.headers.subtotal') }}</td>
          <td v-if="!isDropDown"></td>
          <td class="text-center" v-if="!isDropDown">{{ $t('app.modules.orders.headers.money') }}</td>

        </tr>
      </thead>


      <template v-for="dir  in direcciones">

        <tbody v-if="cartItems.length" :key="dir">

          <!--
      <tr>
        <td v-if="!isDropDown" colspan="10" style="background-color: #bebcba;">
          <span class="font-weight-bold">{{$t("app.modules.orders.form.delivery_address")}}: </span>
          {{ dir }} </td>
      </tr>  
      -->

          <tr is="cart-item" :item="item" :isDropDown="isDropDown" v-for="item in filterDir(dir)" v-bind:key="item.id"
            :editable="editable"></tr>

        </tbody>

      </template>

      <tbody v-if="!cartItems.length">
        <tr>
          <td colspan="5" v-if="!isDropDown" class="text-center text-muted font-italic">{{ $t("app.cart.noItems") }}</td>
          <td colspan="2" v-if="isDropDown" class="text-center text-muted font-italic">{{ $t("app.cart.noItems") }}</td>
        </tr>
      </tbody>
      <tr v-if="cartItems.length">
        <td colspan="6" v-if="!isDropDown" class=" h4">{{ $t("app.cart.total") }}</td>
        <td colspan="4" v-if="!isDropDown" class=" font-weight-bolder h4">{{ $t("app.cart.total") }}</td>
        <td colspan="1" v-if="!isDropDown" class="text-center font-weight-bolder h4">${{ total | currenciFormat() }}</td>
      </tr>
    </table>
  </div>
</template>

<script>
export default {
  name: "cartList",
  props: {
    isDropDown: { type: Boolean, default: false },
    editable: { type: Boolean, default: false }
  },
  watch: {
    editable(newvalue, oldvalue) {
      this.editable = newvalue;
    }
  },
  components: {
    CartItem: () => import("./cartItemRow.vue")
  },
  data() {
    return {
      cartItems: [],
      direcciones: []
    }
  },
  mounted() {
    this.loadItems();
    EventBus.$on("load-cart-items", async () => {
      console.log("Entro a load-cart-items");
      this.loadItems();
    });
  },
  beforeDestroy() {
    //do something before destroying vue instance
    EventBus.$off("load-cart-items");    
  },
  methods: {
    async loadItems() {
      this.$http.get(route("Cart/getCartItems")).then(
        (response) => {
          if (response.body.code === 200) {
            this.direcciones = [];
            this.cartItems = response.body.cart;
            //console.log("Valor de list en load list --> " + JSON.stringify(this.cartItems));

            var fechatest = new Date();
            fechatest.setDate(fechatest.getDate() + 30);

            this.cartItems.forEach(c => {

              if (c.fechaEntrega == fechatest) {
                c.fechaEntrega = fechatest;
              }

              if (c.producto.direccionEntrega != null) {
                if (!this.direcciones.includes(c.producto.direccionEntrega.direccionString)) {
                  this.direcciones.push(c.producto.direccionEntrega.direccionString);
                }

              }
            }
            )
            this.$emit('list1', this.cartItems);

          } else {
            console.log(response.body);
            this.notifyMessage("danger", this.$t("app.promps.error"));
          }
        },
        (error) => {
          console.error(error);
          if (error.status != 401) {
            this.notifyMessage("danger", this.$t("app.promps.error"));
          }
        }
      );
    },
    filterDir(dir) {

      return this.cartItems.filter(item => item.producto.direccionEntrega.direccionString === dir);
    }
  },
  filters: {
    currenciDecimalFormat(amount) {
      if (amount) {
        let decimalCount = 2;
        let decimal = ".";
        let thousands = ",";

        const negativeSign = amount < 0 ? "-" : "";

        let i = parseInt(amount = Math.abs(Number(amount) || 0).toFixed(decimalCount)).toString();
        let j = (i.length > 3) ? i.length % 3 : 0;

        return negativeSign + (j ? i.substr(0, j) + thousands : '') + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousands) + (decimalCount ? decimal + Math.abs(amount - i).toFixed(decimalCount).slice(2) : "");
      }
      return null;
    },
    currenciFormat(value) {
      if (value) {
        let val = (value / 1).toFixed(2).replace(',', '.');
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      }
      return null;
    }
  },
  computed: {
    total() {
      var total = 0;
      this.cartItems.forEach((item) => {
        total += item.cantidad * item.producto.precioUnitario
      });
      return total;
    }
  }
}
</script>

<style scoped>
.shopping_cart_menu {
  max-height: 400px;
  height: auto;
  overflow: auto;
}
</style>
